var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-progress"},[(_vm.canvasId != null)?_c('canvas',{attrs:{"id":_vm.canvasId,"width":_vm.cradius * 2,"height":_vm.cradius * 2}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }